export enum VideoInteractionTypes {
    VIDEO_LOAD = 'VIDEO_LOAD',
    VIDEO_PLAY = 'VIDEO_PLAY',
    VIDEO_PAUSE = 'VIDEO_PAUSE',
    VIDEO_COMPLETE = 'VIDEO_COMPLETE',
    VIDEO_FULLSCREEN = 'VIDEO_FULLSCREEN',
    VIDEO_FULLSCREEN_EXIT = 'VIDEO_FULLSCREEN_EXIT',
    VIDEO_MUTE = 'VIDEO_MUTE',
    VIDEO_UNMUTE = 'VIDEO_UNMUTE',
    VIDEO_CAPTIONS_ON = 'VIDEO_CAPTIONS_ON',
    VIDEO_CAPTIONS_OFF = 'VIDEO_CAPTIONS_OFF'
}

interface TrackEventParams {
    eventAction: VideoInteractionTypes;
    eventLabel: string;
    eventValue: string;
}

interface Params {
    trackEvent: (params: TrackEventParams) => void;
    title: string;
}

const trackVideoEvent = ({trackEvent, title}: Params, eventAction: VideoInteractionTypes) =>
    trackEvent &&
    trackEvent({
        eventAction,
        eventLabel: 'Title',
        eventValue: title
    });

export const trackVideoLoad = (params: Params) =>
    trackVideoEvent(params, VideoInteractionTypes.VIDEO_LOAD);

export const trackVideoPlay = (params: Params) =>
    trackVideoEvent(params, VideoInteractionTypes.VIDEO_PLAY);

export const trackVideoPause = (params: Params) =>
    trackVideoEvent(params, VideoInteractionTypes.VIDEO_PAUSE);

export const trackVideoComplete = (params: Params) =>
    trackVideoEvent(params, VideoInteractionTypes.VIDEO_COMPLETE);

export const trackVideoFullScreen = (params: Params) =>
    trackVideoEvent(params, VideoInteractionTypes.VIDEO_FULLSCREEN);

export const trackVideoFullScreenExit = (params: Params) =>
    trackVideoEvent(params, VideoInteractionTypes.VIDEO_FULLSCREEN_EXIT);

export const trackVideoMute = (params: Params) =>
    trackVideoEvent(params, VideoInteractionTypes.VIDEO_MUTE);

export const trackVideoUnmute = (params: Params) =>
    trackVideoEvent(params, VideoInteractionTypes.VIDEO_UNMUTE);

export const trackVideoCaptions = (params: Params, shown: boolean) =>
    trackVideoEvent(
        params,
        shown ? VideoInteractionTypes.VIDEO_CAPTIONS_ON : VideoInteractionTypes.VIDEO_CAPTIONS_OFF
    );
